import all from './all';
import store from './store';

export default {
  all,
  store,
};



// WEBPACK FOOTER //
// ./src/app/services/organizationMemberProductBusinesshour/index.js